import { render, staticRenderFns } from "./CreateFaq.vue?vue&type=template&id=90e7f030&scoped=true"
import script from "./CreateFaq.vue?vue&type=script&lang=js"
export * from "./CreateFaq.vue?vue&type=script&lang=js"
import style0 from "./CreateFaq.vue?vue&type=style&index=0&id=90e7f030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e7f030",
  null
  
)

export default component.exports